import React, { useEffect, useState } from 'react';
import funemg from '../../assets/funemg.png';
import './style.css';
import { useLocation, useNavigate } from 'react-router-dom';
import PerfilButton from './PerfilButton';
import { removeAllLocalStorage } from '../../utils';
import { useGlobalCarteira } from '../../storage/globalCarteira';
import { carregarImagemLocal } from '../../storage/indexedDbService';

export default function Header() {
    let location = useLocation();
    const navigate = useNavigate();
    const user = localStorage.getItem("user");
    const stateStorage = JSON.parse(user)

    const [loading, setLoading] = useState(false);

    const { dataCarteira } = useGlobalCarteira(state => state)
    const setDataCarteira = useGlobalCarteira(state => state.setDataCarteira); 


    const sair = () => {
        removeAllLocalStorage();
        window.location.reload()
    };

    useEffect(() => {
 

        if (dataCarteira.imagem == undefined) {
            setLoading(true)
            carregarImagemLocal('imagemUser').then(res => {
                setDataCarteira({ ...stateStorage, imagem: res })  
            }).finally(() => {
                setLoading(false);
            });
        }
    }, [])

    const showInLogin = location.pathname !== '/login';

    return (
        <header className="headerContainer"> 
            <img
                onClick={() => navigate('/')}
                className="logo"
                src={funemg}
                alt="Logo Funemg"
            />

            <nav className="navLinks">
                {(localStorage.getItem("tipo") == "ADMINISTRADOR" || localStorage.getItem("tipo") == "FUNCIONARIO") && (
                    <>
                        <h4 className="linkHeader" onClick={() => navigate('/cadastrarCarteira')}>Cadastrar Carteira</h4>
                        <h4 className="linkHeader" onClick={() => navigate('/usuarios/carteira')}>Visualizar Usuários</h4>
                    </>
                )}
                {localStorage.getItem("tipo") == "ADMINISTRADOR" && (
                    <>
                        <h4 className="linkHeader" onClick={() => navigate('/cadastrarFuncionario')}>Cadastrar Funcionário</h4>
                        <h4 className="linkHeader" onClick={() => navigate('/usuarios/metricas')}>Métricas</h4>

                    </>
                )}
            </nav>

            <div className="actions">
                {(localStorage.getItem("tipo") == "ADMINISTRADOR" || localStorage.getItem("tipo") == "FUNCIONARIO") && <button onClick={sair} className="logoutButton">Sair</button>}
                {!user ? (
                    <a href='/login'><button className="loginButton">Entrar</button></a>
                ) : (
                    showInLogin && <PerfilButton />
                )}
            </div>
        </header>
    );
}
